module.exports = __webpack_public_path__ + "img/aq.74e155c6.png";